import React from 'react';
import { Bounds } from '../types';

export interface ScrollMapsGradientProps {
  /**
   * The css gradient representing the Scroll Maps colors.
   */
  gradient: string;
  /**
   * The css bounds for the gradient box (e.g. top, height, width, etc.).
   */
  bounds: Bounds;
}

/**
 * The Scroll Maps gradient responsible for displaying the color overlay.
 */
export const ScrollMapsGradient: React.FC<ScrollMapsGradientProps> = ({ gradient, bounds }) => (
  <div
    data-component="ScrollMapsGradient"
    data-fs="scroll-maps-gradient"
    style={{
      position: 'absolute',
      pointerEvents: 'none',
      top: bounds.top,
      width: bounds.width,
      height: bounds.height,
      zIndex: bounds.zIndex,
      opacity: 0.4,
      background: gradient,
    }}
  />
);
